import React from 'react';
import { Navigate } from 'react-router-dom';
import UserHome from './UserHome';
import { useEntitlements } from '../books/entitlements';

/**
 * `/` (phase 3 spec 2026-09-26 §3): a marked contractor lands on the desk —
 * Home on the money plan, which sends the design plan on to Jobs, where
 * their design projects are listed with their jobs. Everyone else keeps
 * today's projects page.
 */
export default function HomeRoute() {
  const { contractor } = useEntitlements();
  return contractor ? <Navigate to="/books" replace /> : <UserHome />;
}
